export type FileWithUniqueId = File & {
    uniqueId: number | string;
};

export type FileWithProgress = FileWithUniqueId & {
    progress?: number;
    abortController?: AbortController;
    error?: string;
    name?: string;
    size?: number;
};

export enum FileType {
    PLAN = 'PLAN',
    FACT = 'FACT',
    ALL = 'ALL',
}
